module.exports = __webpack_public_path__ + "img/dancevetor-min.41cf8374.png";